import VDataIterator from './VDataIterator'
import VDataFooter from './VDataFooter'

export { VDataIterator, VDataFooter }
export default {
  $_ifrontui_subcomponents: {
    VDataIterator,
    VDataFooter,
  },
}
